import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface ExecuteMethodInput {
  _package: string;
  _class: string;
  _method: string;
  params?: any;
  ignoreInput?: boolean;
  ignoreOutput?: boolean;
}

export interface ExecuteMethodOutput {
  result?: any;
  object?: any;
  view?: string;
  _redirectURL?: string;
}

export async function executeMethod(input: ExecuteMethodInput): Promise<FetchResponse<ExecuteMethodOutput>> {
  return await portalCustomAPI.fetch<ExecuteMethodInput, ExecuteMethodOutput>('executeMethod', input);
}
